module.exports = __webpack_public_path__ + "img/goldregen-2020-024.be7481f3.jpg";